import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import config from '../../config';
import ColorSF2 from '../../styles/common/ColorSF2';
import AddCompanyButton from '../Parts/CreateEntityButton';

const Main = styled.div`
  height: 50px;
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: ${ColorSF2.paleBlue};
  padding: 0 10px;
  @media (max-height: 530px) {
    height: 30px;
  }
`;
const style = {
  contents: {
    height: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  contentsTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontWeight: 'bold',
    color: ColorSF2.black,
  },
  addCompanyButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px 10px',
    borderRadius: 5,
    backgroundColor: ColorSF2.green,
    color: ColorSF2.white,
    fontSize: '12px',
    cursor: 'pointer',
  },
  svgWrapper: {
    marginRight: '3px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
};

const { createCompany } = config.customRole.functionAccess;

/**
 * 企業管理のヘッダーコンポーネント
 *
 * @param {*} param0
 * @param role
 * @returns
 */
const CompanyTitle = ({ role, onCreateCompany }) => {
  const displayCreateCompany = createCompany.indexOf(role) !== -1;
  return (
    <Main className="companyTitle">
      <div style={style.contents}>
        <div style={style.contentsTitle}>
          <FormattedMessage id="company.title" />
        </div>
        {displayCreateCompany && (
          <AddCompanyButton
            onCreate={onCreateCompany}
            labelId="company.CompanyTitle.createCompanyButton.name"
          />
        )}
      </div>
    </Main>
  );
};

CompanyTitle.propTypes = {
  role: PropTypes.number.isRequired,
  onCreateCompany: PropTypes.func.isRequired,
};

export default CompanyTitle;
